import { debounce } from '../utils';

const initialize = () => {
    $('.page-nav-label').click(function() {
        $(this).parents('.page-nav').toggleClass('active');
    });
    $('.banner-menu-button').click(function() {
        $(this).parents('.banner-menu').toggleClass('active');
    });

    $(window).resize(
        debounce(
            () => {
                $('.page-nav').removeClass('active');
            },
            50
        )
    );
};

export default {
    initialize,
};

